import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";
const MyInput = ({
  title,
  name,
  register,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  pattern,
  patternMsg,
  readonly=false
}) => {
  const error = get(errors, name);
  return (
    <div className="form-group ">
      <MyLabel name={name} title={title} required={required} />
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type="text"
          id={name}
          {...register(name, {
            required: required
              ? {
                  value: true,
                  message: `${title || name} is required`,
                }
              : false,
            pattern: {
              value: pattern,
              message: patternMsg,
            },
            minLength: min
              ? {
                  value: min,
                  message: `${title || name} must be at least ${min} characters`,
                }
              : undefined,
            maxLength: max
              ? {
                  value: max,
                  message: `${title || name} must be at most ${max} characters`,
                }
              : undefined,
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            setValue(name, e.target.value, { shouldValidate: true });
          }}
          readOnly={readonly}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyInput;
